import AnchorIf from "@/components/common/AnchorIf";
import Picture from "@/components/common/Picture";
import type { ExtendedUploadedImage } from "@/types";
import s from "./SponsorVariant2.module.scss";

export interface SponsorVariant2Props {
  url: string;
  logo: ExtendedUploadedImage;
  disableLink: boolean;
  openInNewTab?: boolean;
}

export default function SponsorVariant2(props: SponsorVariant2Props) {
  const { url, logo, disableLink, openInNewTab } = props;

  return (
    <AnchorIf
      href={disableLink ? "" : url}
      openInNewTab={openInNewTab}
      className={s.wrapper}
    >
      <Picture imageConfig={logo} />
    </AnchorIf>
  );
}
